import PropTypes from 'prop-types';

import { PartnerPhoto } from '../../partner-photo';
import styles from './PartnerInfo.scss';

export const PartnerInfo = ({
  name,
  photoUrl = '',
  description = null,
  instagram = null,
  partnerTitle,
  partnerPrefix,
  hidePartnerPrefix = false,
  hidePartnerNameUnderline = false,
  hidePartnerDescription = false,
}) => (
  <div className={styles.PartnerInfo}>
    <div className={styles.Meta}>
      <PartnerPhoto partner={{ photoUrl, name }} />
      <div>
        <h3 className={hidePartnerNameUnderline ? styles.Name_without_underline : styles.Name}>
          {name}
        </h3>
        <p className={styles.Position}>
          {!hidePartnerPrefix && partnerPrefix} {partnerTitle}
        </p>
      </div>
    </div>
    {!hidePartnerDescription && (description || instagram) && (
      <div className={styles.Description}>
        <p>
          {description}{' '}
          {instagram && (
            <a
              href={`https://www.instagram.com/${instagram}/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {`Follow\u00A0@${instagram}`}
            </a>
          )}
        </p>
      </div>
    )}
  </div>
);

PartnerInfo.propTypes = {
  name: PropTypes.string.isRequired,
  photoUrl: PropTypes.string,
  description: PropTypes.string,
  instagram: PropTypes.string,
  partnerTitle: PropTypes.string.isRequired,
  partnerPrefix: PropTypes.string,
  hidePartnerPrefix: PropTypes.bool,
  hidePartnerNameUnderline: PropTypes.bool,
  hidePartnerDescription: PropTypes.bool,
};
